import { useMemo } from 'react';

// Eksensiz minik trend çizgisi. data: [{ t, v }] | [number]
export default function Sparkline({ data = [], width = 132, height = 36, color = 'var(--accent)', fill = true }) {
  const pts = useMemo(() => {
    const arr = (data || [])
      .map((d, i) => (typeof d === 'number' ? { x: i, v: d } : { x: +new Date(d.t) || 0, v: Number(d.v) }))
      .filter((d) => Number.isFinite(d.v));
    return arr;
  }, [data]);

  if (pts.length < 2) return <div style={{ height, width, opacity: 0.3, fontSize: 11, display: 'grid', placeItems: 'center' }}>—</div>;

  const xs = pts.map((p) => p.x);
  const vs = pts.map((p) => p.v);
  const minX = Math.min(...xs), maxX = Math.max(...xs);
  const minV = Math.min(...vs), maxV = Math.max(...vs);
  const spanX = maxX - minX || 1;
  const spanV = maxV - minV || 1;
  const pad = 3;
  const X = (x) => pad + ((x - minX) / spanX) * (width - pad * 2);
  const Y = (v) => pad + (1 - (v - minV) / spanV) * (height - pad * 2);

  const line = pts.map((p, i) => `${i ? 'L' : 'M'} ${X(p.x).toFixed(1)} ${Y(p.v).toFixed(1)}`).join(' ');
  const area = `${line} L ${X(maxX).toFixed(1)} ${height - pad} L ${X(minX).toFixed(1)} ${height - pad} Z`;
  const gid = 'sp' + Math.abs(pts[0].v + pts.length + width).toString(36);

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block', overflow: 'visible' }}>
      {fill && (
        <>
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.20" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={area} fill={`url(#${gid})`} />
        </>
      )}
      <path d={line} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <circle cx={X(pts[pts.length - 1].x)} cy={Y(pts[pts.length - 1].v)} r="2.2" fill={color} />
    </svg>
  );
}
